import SelectDocument from './SelectDocument'

export default SelectDocument
